import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { serialize } from 'object-to-formdata'

const MOTIVOS_SUBIDA = {
    tipo_no_permitido: 'formato no permitido',
    nombre_invalido: 'nombre de archivo inválido',
    ruta_invalida: 'destino inválido',
    error_subida: 'no se completó la carga',
}

// Arma el mensaje del snack a partir de la respuesta 4xx/5xx de portal/subirArchivos
const mensajeErrorSubida = (error) => {
    const errores = error && error.response && error.response.data && error.response.data.error
    if (Array.isArray(errores) && errores.length) {
        const detalle = errores
            .map(e => `${e.archivo} (${MOTIVOS_SUBIDA[e.motivo] || 'error al guardar'})`)
            .join(', ')
        return `No se pudo subir: ${detalle}.`
    }
    return 'No se pudo subir el archivo. Intente nuevamente más tarde.'
}

const defaultState = () => ({
    fototmp: '',
    fototmpcarnet: '',
    pre_id: '',
    fotoPerfil: '',
    fotoCarnet: '',
    datosPersonales: {},
    dniFrenteAfiliado: [],
    dniDorsoAfiliado: [],
    certAfiliado: [],
    objetoEstadoCivil: {},
    partidaNacimiento: [],
    sentenciaAdopcion: [],
    comprobante: [],
    datosAfiliado: {},
    formDataPersonales: {},
    datosFamiliares: {},
    datosProfesionales: {},
    datosNivel: {},
    formDataFamiliares: {},
    archPersonales: [],
    archFamiliares: [],
    archFamiliares1: [],
    archFamiliares2: [],
    reciboSueldoHaberes: [],
    resolucionJubilacion: [],
    archNivel: [],
    archNivel1: [],
    archProfesionales: [],
    archPareja: [],
    archHistMatricula: [],
    formData: {},
    preFamiliares: [],
    preArchFamiliares: [],
    dniFrenteFamiliar: [],
    dniDorsoFamiliar: [],
    certDiscFamiliar: [],
    certFamiliar: [],
    certDisc: [],
    datosFamiliaresMasConyuge: [],
    blockFotoCarnet: false,
    hayDatosFamiliares: false,
    hayDatosPersonales: false,
    labelTipoFamiliar: '',
    errorMod: false,
});

Vue.use(Vuex)

export default ({
    namespaced: true,

    state: defaultState(),

    getters: {
        tarjetaFrente(state) {
            return state.comprobanteCbu
        },
        comprobanteCbu(state) {
            return state.comprobanteCbu
        },
        comprobante(state) {
            return state.comprobante
        },
        partidaNacimiento(state) {
            return state.partidaNacimiento
        },
        datosFamiliaresMasConyuge(state) {
            return state.datosFamiliaresMasConyuge
        },
        sentenciaAdopcion(state) {
            return state.sentenciaAdopcion
        },
        blockFotoCarnet(state) {
            return state.blockFotoCarnet
        },
        datosPersonales(state) {
            return state.datosPersonales
        },
        datosAfiliado(state) {
            return state.datosAfiliado
        },
        dniFrenteAfiliado(state) {
            return state.dniFrenteAfiliado
        },
        dniDorsoAfiliado(state) {
            return state.dniDorsoAfiliado
        },
        certAfiliado(state) {
            return state.certAfiliado
        },
        dniFrenteFamiliar(state) {
            return state.dniFrenteFamiliar
        },
        dniDorsoFamiliar(state) {
            return state.dniDorsoFamiliar
        },
        certDiscFamiliar(state) {
            return state.certDiscFamiliar
        },
        certDisc(state) {
            return state.certDisc
        },
        certFamiliar(state) {
            return state.certFamiliar
        },
        datosFamiliares(state) {
            return state.datosFamiliares
        },
        preFamiliares(state) {
            return state.preFamiliares
        },
        preArchFamiliares(state) {
            return state.preArchFamiliares
        },
        reciboSueldoHaberes(state) {
            return state.reciboSueldoHaberes
        },
        resolucionJubilacion(state) {
            return state.resolucionJubilacion
        },
        archNivel(state) {
            return state.archNivel
        },
        archNivel1(state) {
            return state.archNivel1
        },
        datosNivel(state) {
            return state.datosNivel
        },
        fototmp(state) {
            return state.fototmp
        },
        fototmpcarnet(state) {
            return state.fototmpcarnet
        },
        pre_id(state) {
            return state.pre_id
        },
        fotoPerfil(state) {
            return state.fotoPerfil
        },
        fotoCarnet(state) {
            return state.fotoCarnet
        },
        archFamiliares(state) {
            return state.archFamiliares
        },
        hayDatosFamiliares(state) {
            return state.hayDatosFamiliares
        },
        hayDatosPersonales(state) {
            return state.hayDatosPersonales
        },
        labelTipoFamiliar(state) {
            return state.labelTipoFamiliar
        },
        errorMod(state) {
            return state.errorMod
        },
        objetoEstadoCivil(state) {
            return state.objetoEstadoCivil
        }

    },
    mutations: {
        // dispatch('actualizarDatos', formData)
        RESET_STATE(state) {
            Object.assign(state, defaultState())
        },
        setFormData(state, payload) {
            state.formData = payload
        },
        setErrorMod(state, payload) {
            state.errorMod = payload
        },
        setPreFamiliares(state, payload) {
            if (payload.length !== 0) {
                payload.forEach(element => {
                    element.accion = 'X'
                    state.preArchFamiliares.push([])
                });
                state.preFamiliares = payload
            } else {
                state.preFamiliares = []
                state.preArchFamiliares = []
            }
        },
        setPreArchFamiliares(state, payload) {
            state.preArchFamiliares[payload.indice] = payload.archFamiliar
        },
        setDatosPersonales(state, payload) {
            if (typeof payload == 'object' && Object.keys(payload).length !== 0) {
                state.datosPersonales = payload
                state.hayDatosPersonales = true

            } else {
                state.datosPersonales = {}
                state.hayDatosPersonales = false
            }
        },
        setDatosAfiliado(state, payload) {
            state.datosAfiliado = payload
        },
        setObjetoEstadoCivil(state, payload) {
            state.objetoEstadoCivil = payload
        },

        setDatosFamiliaresMasConyuge(state, payload) {
            state.datosFamiliaresMasConyuge = payload
        },
        setDatosNivel(state, payload) {
            state.datosNivel = payload
        },
        setFototmp(state, fototmp) {
            state.fototmp = fototmp
        },
        setFototmpCarnet(state, payload) {
            state.fototmpcarnet = payload
        },
        setPreId(state, pre_id) {
            state.pre_id = pre_id
        },
        setFotoCarnet(state, payload) {
            state.blockFotoCarnet = true
            state.fotoCarnet = payload
        },
        setFotoPerfil(state, payload) {
            state.fotoPerfil = payload
        },
        setArchivos(state, payload) {
            switch (payload.op) {
                case 'dniFrenteAfiliado':
                    // Siempre reemplazar con un solo archivo
                    state.dniFrenteAfiliado = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'dniDorsoAfiliado':
                    // Siempre reemplazar con un solo archivo
                    state.dniDorsoAfiliado = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'certAfiliado':
                    // Siempre reemplazar con un solo archivo
                    state.certAfiliado = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'certDisc':
                    // Siempre reemplazar con un solo archivo
                    state.certDisc = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'personales':
                    // Siempre reemplazar con un solo archivo
                    state.archPersonales = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'archNivel':
                    // Siempre reemplazar con un solo archivo
                    state.archNivel = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'reciboSueldoHaberes':
                    // Siempre reemplazar con un solo archivo
                    state.reciboSueldoHaberes = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'resolucionJubilacion':
                    // Siempre reemplazar con un solo archivo
                    state.resolucionJubilacion = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'familiar':
                    // Siempre reemplazar con un solo archivo
                    state.archFamiliares = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'dniFrenteFamiliar':
                    // Siempre reemplazar con un solo archivo
                    state.dniFrenteFamiliar = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'dniDorsoFamiliar':
                    // Siempre reemplazar con un solo archivo
                    state.dniDorsoFamiliar = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'certDiscFamiliar':
                    // Siempre reemplazar con un solo archivo
                    state.certDiscFamiliar = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'certFamiliar':
                    // Siempre reemplazar con un solo archivo
                    state.certFamiliar = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'certDefuncionFamiliar':
                    // Siempre reemplazar con un solo archivo
                    state.certDefuncionFamiliar = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'partidaNacimiento':
                    // Siempre reemplazar con un solo archivo
                    state.partidaNacimiento = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'sentenciaAdopcion':
                    // Siempre reemplazar con un solo archivo
                    state.sentenciaAdopcion = (payload.file !== '') ? [payload.file] : []
                    break;
                case 'comprobanteCbu':
                case 'tarjetaFrente':
                    // Siempre reemplazar con un solo archivo
                    state.comprobante = (payload.file !== '') ? [payload.file] : []
                    break;
            }
        },
        borrarArchivo(state, payload) {
            switch (payload.op) {
                case 'personales':
                    state.archPersonales.splice(payload.index, 1)
                    break;
                case 'profesionales':
                    state.archProfesionales.splice(payload.index, 1)
                    break;
                case 'pareja':
                    state.archPareja.splice(payload.index, 1)
                    break;
                case 'histomatricula':
                    state.archHistMatricula = archHistMatricula.splice(payload.index, 1)
                    break;
                case 'familiar':
                    state.archFamiliares.splice(payload.index, 1)
                    break;
                case 'familiar1':
                    state.archFamiliares1.splice(payload.index, 1)
                    break;
                case 'familiar2':
                    state.archFamiliares2.splice(payload.index, 1)
                    break;
            }
        },
        borrarArchFam(state) {
            state.preArchFamiliares = []
            //elimino los archivos de familiares
            state.dniFrenteFamiliar = []
            state.dniDorsoFamiliar = []
            state.certDiscFamiliar = []
            state.certFamiliar = []
        }
    },
    actions: {
        resetDataUser({ commit }) {
            commit('RESET_STATE');
        },
        guardarObjetoEstadoCivil({ commit }, payload) {
            commit('setObjetoEstadoCivil', payload)
        },
        async guardarFotoCarnet({ commit, dispatch, state }) {
            commit('setFototmpCarnet', state.fototmp)
        },
        //fotos afiliado
        async subirFotoCarnet({ commit, dispatch, state }, payload) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/afiliado',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                data: JSON.stringify(payload),
            }).then((response) => {
                const res = response.data

                //setea fotoCarnet 
                //commit('setFotoCarnet', payload.fotocarnet)

                //limpio fototmpcarnet = ''
                dispatch('precargaFotoCarnet', '')

                dispatch('refreshData', null, { root: true })

                //dispatch('auth/getUser', sessionStorage.getItem('nroafi'), { root: true })
            }).catch(function (error) {
                console.log(error)
            })
        },

        async subirFotoPerfil({ commit, dispatch }, payload) {
            await axios({
                method: 'put',
                url: process.env.VUE_APP_API + 'portal/usuario',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                data: JSON.stringify(payload),
            }).then((response) => {
                const res = response.data
                //setea fotoPerfil 
                commit('setFotoPerfil', payload.fotoperfil)
                //limpio fototmp = ''
                dispatch('precargaFoto', '')

                //dispatch('auth/getUser', null, { root: true })
                //dispatch('auth/getUser', sessionStorage.getItem('nroafi'), { root: true })
                dispatch('notificaciones/startLoading', null, { root: true })

            }).catch(function (error) {
                dispatch('precargaFoto', '')
            }).finally(() => {
                dispatch('auth/getUser', { nroafi: sessionStorage.getItem('nroafi'), bit: 0 }, { root: true })
                dispatch('notificaciones/stopLoading', null, { root: true })
            })
        },
        async precargaFoto({ commit, dispatch }, data) {
            commit('setFototmp', data)
        },
        async precargaFotoCarnet({ commit, dispatch }, data) {
            commit('setFototmpCarnet', data)
        },
        //metodo para cambio de contraseña que requiere token
        async cambiarPassword({ commit, dispatch }, obj) {
            await axios({
                method: 'put',
                url: process.env.VUE_APP_API + 'portal/usuario',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                data: JSON.stringify(obj),
            }).then((response) => {
                const res = response.data.code
                dispatch('notificaciones/showSnack', {
                    message: "Actualizacion correcta. Cerrando sesión....",
                    type: "200",
                }, { root: true })
            }).catch(function (error) {
                dispatch('notificaciones/showSnack', {
                    message: "No se pudo actualizar su contraseña.",
                    type: "400",
                }, { root: true })
            })
        },

        async subirFotoAfiliado({ commit, dispatch }, formData) {
            return axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/subirArchivos',
                withCredentials: false,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                data: formData,
            }).then((response) => {
                return response.data
            }).catch(function (error) {
                dispatch('notificaciones/showSnack', {
                    message: mensajeErrorSubida(error),
                    type: "400",
                }, { root: true })
                return null
            })
        },
        guardarDatosAfiliado({ commit }, payload) {
            commit('setDatosAfiliado', payload)
        },
        guardarDatosPersonales({ commit }, payload) {
            commit('setDatosPersonales', payload)
        },
        guardarDatosFamiliaresMasConyuge({ commit, dispatch }, payload) {
            commit('setDatosFamiliaresMasConyuge', payload)
        },
        guardarDatosNivel({ commit }, payload) {
            commit('setDatosNivel', payload)
        },
        //enviar datos familiar
        enviarFamiliar({ state }, formData) {
            if (state.archFamiliares) {
                let files = state.archPersonales
                for (let i = 0; i < files.length; i++)
                    formData.append(`archFamiliares${i}`, files[i]);
                commit('setFormData', formData)
                // dispatch('actualizarDatos', formData)
            }
        },
        //** en uso para archivos personales*/
        async cargarFormDataArchivos({ commit, state, dispatch }, formData) {
            if (state.archPersonales) {
                let files = state.archPersonales
                for (let i = 0; i < files.length; i++) {
                    formData.append(`archPersonales${i}`, files[i]);
                    console.log(formData)
                }
                commit('setFormData', formData)
                // dispatch('actualizarDatos', formData)
            }

        },
        crearFormDataPersonales({ state, dispatch }) {
            const options = {
                indices: true,
                nullsAsUndefineds: false,
                booleansAsIntegers: false,
                allowEmptyArrays: false,
                noFilesWithArrayNotation: false,
                dotsForObjectNotation: false,
            }
            let data = {
                datosPersonales: state.datosPersonales,
                archPersonales: state.archPersonales
            }
            const formData = serialize(
                data,
                options,
            )
            console.log(formData)
            dispatch('actualizarDatos', formData)
        },
        // form data para nivel de afiliado
        crearFormDataNivel({ state, dispatch }, data) {
            let keys = Object.keys(data)
            let formData = new FormData()
            for (let i = 0; i < keys.length; i++) {
                formData.append(keys[i], data[keys[i]]);
                console.log(keys[i] + ' : ' + data[keys[i]])
            }
            if (state.reciboSueldoHaberes.length > 0) {
                formData.append('reciboSueldoHaberes', state.reciboSueldoHaberes[0]);
            }
            if (state.archNivel.length > 0) {
                formData.append('certificadoLaboral', state.archNivel[0]);
            }
            dispatch('opcionNivel/nuevaOpcionNivel', formData, { root: true })

        },

        async actualizarDatos({ commit, dispatch, state }, formData) {
            dispatch('notificaciones/startLoading', null, { root: true })
            try {
                const response = await axios({
                    method: 'post',
                    url: process.env.VUE_APP_API + 'portal/afiliado',
                    withCredentials: false,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: formData,
                })
                const res = response.data.message
                const nrotramite = response.data.message.pma_id
                const code = response.data.message.success
                dispatch('notificaciones/showSnack', {
                    message: `Su trámite nº ${nrotramite} ha sido enviado correctamente y se encuentra en estado pendiente.`,
                    type: code.toString(),
                }, { root: true })
                return true
            } catch (error) {
                dispatch('notificaciones/showSnack', {
                    message: `Error al intentar iniciar el trámite.`,
                    type: '400',
                }, { root: true })
                return false
            } finally {
                dispatch('notificaciones/stopLoading', null, { root: true })
            }
        },
        addFiles({ commit }, payload) {
            commit('setArchivos', payload)
        },
        deleteFiles({ commit }, payload) {
            commit('setArchivos', payload)
        },
        deleteItem({ commit }, payload) {
            commit('borrarArchivo', payload)
        },
        deleteAllArchFam({ commit }) {
            commit('borrarArchFam')
        },
        async subirArchivos({ commit, dispatch }, formData) {
            return axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/subirArchivos',
                withCredentials: false,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                data: formData,
            }).then((response) => {
                return response.data
            }).catch(function (error) {
                dispatch('notificaciones/showSnack', {
                    message: mensajeErrorSubida(error),
                    type: "400",
                }, { root: true })
                return null
            })
        },

        async preparaFormFamiliares({ state, commit, dispatch, rootGetters }, formData) {
            state.preFamiliares.forEach((familiar, index) => {
                for (const key in familiar) {
                    if (key == 'nroafi') {
                        formData.append(`familiares[${index}][${key}]`, rootGetters['auth/nroafi'])
                    }
                    else { formData.append(`familiares[${index}][${key}]`, familiar[key]) }
                }
                if (state.preArchFamiliares[index] && state.preArchFamiliares[index].length > 0) {
                    state.preArchFamiliares[index].forEach((archivo, indice) => {
                        if (archivo) {
                            formData.append(`familiares_archivos[${index}][${archivo.name}]`, archivo.file)
                        }
                    })
                }
            })
            dispatch('dataUser/actualizarDatos', formData, { root: true })
        },
        async preparaFormPersonales({ commit, dispatch, state, rootGetters }) {
            let formData = new FormData()
            if (state.hayDatosPersonales) {
                let keys = Object.keys(state.datosPersonales)
                for (let i = 0; i < keys.length; i++) {
                    formData.append(`afiliado[${keys[i]}]`, state.datosPersonales[keys[i]])
                }
                if (state.dniFrenteAfiliado && state.dniDorsoAfiliado) {
                    formData.append(`afiliado_archivos[apa_dni_frente]`, state.dniFrenteAfiliado[0])
                    formData.append(`afiliado_archivos[apa_dni_dorso]`, state.dniDorsoAfiliado[0])
                }
            } else {
                formData.append(`afiliado[nroafi]`, rootGetters['auth/nroafi'])
            }
            if (false) {
                dispatch('dataUser/preparaFormFamiliares', formData, { root: true })
            } else {
                commit('setErrorMod', true)
                // Devuelve el valor retornado por actualizarDatos
                return await dispatch('dataUser/actualizarDatos', formData, { root: true })
            }
        },
        async preparaFormData({ commit, dispatch, state }) {
            const formData = new FormData()
            // Agregar datos personales al FormData
            for (const key in state.datosPersonales) {
                formData.append(`afiliado[${key}]`, state.datosPersonales[key])
            }
            // Agregar dniFrenteAfiliado y dniDorsoAfiliado al FormData
            if (state.dniFrenteAfiliado.length !== 0 && state.dniDorsoAfiliado.length !== 0) {
                formData.append(`afiliado_archivos[apa_dni_frente]`, state.dniFrenteAfiliado[0])
                formData.append(`afiliado_archivos[apa_dni_dorso]`, state.dniDorsoAfiliado[0])
            }
            // Agregar datosFamiliaresMasConyuge al FormData
            state.datosFamiliaresMasConyuge.forEach((familiar, index) => {
                for (const key in familiar) {
                    formData.append(`familiares[${index}][${key}]`, familiar[key])
                    if (key == 'accion' && familiar[key] == 'M') {
                        if ((state.dniFrenteFamiliar.length !== 0) && (state.dniDorsoFamiliar.length !== 0)) {
                            formData.append(`familiares_archivos[${index}][apa_dni_frente]`, state.dniFrenteFamiliar[0])
                            formData.append(`familiares_archivos[${index}][apa_dni_dorso]`, state.dniDorsoFamiliar[0])
                        }
                        if (state.certFamiliar.length !== 0) {
                            formData.append(`familiares_archivos[${index}][apa_cert_familiar]`, state.certFamiliar[0])
                        }
                    }
                }
            })
            // Agregar archivos de familiares dniFrenteFamiliar, dniDorsoFamiliar (si son requeridos) y certFamiliar (siempre) al FormData
            console.log("Contenido del FormData:");
            for (let pair of formData.entries()) {
                console.log(`${pair[0]}: ${pair[1]}`);
            }
            return await dispatch('dataUser/actualizarDatos', formData, { root: true })
        },

        copiarFamiliares({ commit, dispatch, state }) {
            commit('setPreFamiliares', this.getters.familiar)
        },
        deleteAllFam({ commit, dispatch, state }) {
            commit('setPreFamiliares', [])
        },
        agregarArchFam({ commit, dispatch }, data) {
            commit('setPreArchFamiliares', data)
        },
        modificarFamiliar({ commit, dispatch }, data) {
            commit('setModFam', data)
        },
        nuevoFamiliar({ commit, dispatch }, data) {
            commit('setNuevoFam', data)
        },
        setHayDatosFamiliares({ state, commit, dispatch }) {
            state.hayDatosFamiliares = true
        },
        setFotoCarnetAfiliado({ state, commit, dispatch }, data) {
            commit('setFotoCarnet', data)
        },
        setFotoPerfilAfiliado({ state, commit, dispatch }, data) {
            commit('setFotoPerfil', data)
        },
    },
})